import { render, staticRenderFns } from "./authGoodsConfig.vue?vue&type=template&id=2418e602&scope=scope"
import script from "./authGoodsConfig.vue?vue&type=script&lang=js"
export * from "./authGoodsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports